import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/auth/forgot-password/ForgotPasswordForm.tsx");
